let wsAuthToken = ''

export const setWebSocketAuthToken = (token?: string | null) => {
  wsAuthToken = token ?? ''
}

export const getWebSocketAuthToken = () => wsAuthToken

export const clearWebSocketAuthToken = () => {
  wsAuthToken = ''
}
